import React from 'react';
import { Card } from './ui/card';
import { MapPin, Calendar, Snowflake, ShieldCheck, Users, Award } from 'lucide-react';
import { mockFeatures } from '../data/mock';

const iconMap = {
  MapPin,
  Calendar,
  Snowflake,
  ShieldCheck,
  Users,
  Award
};

const WhyChoose = () => {
  return (
    <section className="py-20 bg-white relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gold/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-burgundy/5 rounded-full blur-3xl"></div>

      <div className="container mx-auto px-4 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <h2 className="text-4xl md:text-5xl font-bold text-burgundy mb-6">
            Pourquoi choisir Volaille Prime ?
          </h2>
          <p className="text-lg text-gray-700 leading-relaxed">
            Chez Volaille Prime, nous mettons l'accent sur la qualité, la discipline de production et la fiabilité. Notre objectif est simple : vous fournir un produit sûr, constant et accessible.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
          {mockFeatures.map((feature, index) => {
            const Icon = iconMap[feature.icon];
            return (
              <Card 
                key={feature.id}
                className="p-8 bg-white border-2 border-gray-100 hover:border-burgundy/30 hover:shadow-xl transition-all duration-300 group cursor-pointer animate-fade-in-up"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="flex flex-col items-start">
                  {/* Icon */}
                  <div className="mb-5 p-4 bg-burgundy/10 rounded-2xl group-hover:bg-burgundy group-hover:scale-110 transition-all duration-300">
                    <Icon size={32} className="text-burgundy group-hover:text-white transition-colors" />
                  </div>
                  
                  {/* Title */}
                  <h3 className="text-xl font-bold text-gray-900 mb-3 group-hover:text-burgundy transition-colors">
                    {feature.title}
                  </h3>
                  
                  {/* Description */}
                  <p className="text-gray-600 leading-relaxed">
                    {feature.description}
                  </p>
                </div>
              </Card>
            );
          })}
        </div>

        {/* Bottom CTA */}
        <div className="mt-16 text-center">
          <div className="inline-block p-8 bg-gradient-to-br from-burgundy/5 to-gold/5 rounded-3xl border-2 border-burgundy/10">
            <p className="text-2xl font-semibold text-gray-900">
              Production fiable • Qualité garantie • Service professionnel
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyChoose;
